export const labelPositionSelector = ({labelPosition}) => labelPosition